import { createSelector, createSlice } from "@reduxjs/toolkit";
import * as hooks from "lib/hooks";
import { SimpleSetter, SliceActions } from "store";
import { BaseEntity } from "BaseEntity";
import { ContainmentFilterKey } from "enums/filters";
import { Containment } from "models";
import { Crud } from "enums/crud";
import * as crud from "enums/crud";
import * as opt from "lib/opt";

export type PlantType = BaseEntity;

export type SectorName = "GPS" | "RESS";
export type SectorFileTemplate =
	| `MCC_${SectorName}_UPLOAD_TEMPLATE.xlsx`
	| `MCC_${SectorName}_SERIAL_UPLOAD_TEMPLATE.xlsx`;

type dashboardFilters = Record<ContainmentFilterKey | "sort", string>;
export type DashboardFiltersCtx = ReturnType<
	typeof hooks.UseSearchFilters<
		Containment,
		dashboardFilters,
		ContainmentFilterKey
	>
>;

export type ContainmentState = {
	containments: Containment[];
	selectedContainment: opt.Opt<Containment>;
	mode: Crud;
};

const initialState: ContainmentState = {
	containments: [],
	selectedContainment: opt.None(),
	mode: crud.Read(),
};

export const ContainmentsSlice = createSlice({
	name: "containments",
	initialState: initialState,
	reducers: {
		Set: SimpleSetter<ContainmentState, Containment[]>("containments"),
		SetSelectedContainment: SimpleSetter<
			ContainmentState,
			opt.Opt<Containment>
		>("selectedContainment"),
		SetMode: SimpleSetter<ContainmentState, Crud>("mode"),
		CloseSidebar: (state) => {
			state.mode = crud.Read();
			state.selectedContainment = opt.None<Containment>();
		},
	},
	selectors: {
		selectContainments: (state) => state.containments,
		selectSelectedContainment: (state) => state.selectedContainment,
		selectMode: (s) => s.mode,
	},
});

export const SelectContainmentById = createSelector(
	[ContainmentsSlice.selectors.selectContainments, (s, id?: string) => id],
	(containments, id) => containments.Find((c) => c.id === id)
);

export type ContainmentAction = SliceActions<typeof ContainmentsSlice>;
